import React, { useState } from "react";
import './MenuFrontal.scss'
import { useLocation, useNavigate } from "react-router-dom";
import arrowLeftIcon from '../../../assets/icons/arrow_left_icon.svg'
const MenuCompletoMovil = ({ menuData }) => {
    const navigate = useNavigate();
    const [openMenuIndex, setOpenMenuIndex] = useState()
    const showSubMenu = () => {
        setOpenMenuIndex(!openMenuIndex);
    };
    const handleSubMenuClick = (url) => {
        navigate(url);
        setOpenMenuIndex(null);
    };
    return (
        <>

            <div className="MenuCompletoMovil">
                <div className={`MenuItem  ${openMenuIndex?"seleccionado":""}`} onClick={showSubMenu}>
                    <div className="title">Modulos</div>
                    <div className="iconContainer">
                        <img src={arrowLeftIcon}></img>
                    </div>
                    {openMenuIndex && (
                        <div className="subMenu">
                            {
                                menuData.map((menu) => {
                                    return (
                                        <>
                                            {
                                                menu.subMenu.length > 0 ?
                                                    <>
                                                        {
                                                            menu.subMenu.map((subMenu) => {
                                                                return (
                                                                    <>
                                                                        <div
                                                                            className="titleSubMenu"
                                                                            key={subMenu.title}
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                handleSubMenuClick(subMenu.url);
                                                                            }}
                                                                        >
                                                                            {subMenu.title}
                                                                        </div>
                                                                    </>
                                                                )
                                                            })
                                                        }
                                                    </> :
                                                    <>
                                                        <div
                                                            className="titleSubMenu"
                                                            key={menu.title}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleSubMenuClick(menu.url);
                                                            }}
                                                        >
                                                            {menu.title}
                                                        </div>
                                                    </>

                                            }
                                        </>
                                    )
                                })
                            }
                        </div>
                    )}
                </div>

            </div >
        </>
    )
}
export default MenuCompletoMovil